import { render } from "./VideoWallPlayer.vue?vue&type=template&id=5088d4ea&ts=true"
import script from "./VideoWallPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoWallPlayer.vue?vue&type=script&lang=ts"

import "./VideoWallPlayer.vue?vue&type=style&index=0&id=5088d4ea&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__